<section id="service-settings-container">
  <form [formGroup]="settingsForm">
    <section id='header'>
      <div class='title'>
        <div class='main'>{{ 'generalSettings.serviceGeneralSettings'| translate}}</div>
      </div>

      <div class='actions'>
        <div class='cancel' (click)="cancel()">{{ 'generalSettings.cancel' | translate }}</div>
        <div class='save-changes' (click)="saveChanges()">
          <ng-container *ngIf="saveInProgress; else serviceSaveLabel">
            <app-loading loadingSymbol="dots" [text]="'saving' | translate" color="white" size=".7" [compact]="true"></app-loading>
          </ng-container>
          <ng-template #serviceSaveLabel>{{ 'generalSettings.saveChanges' | translate }}</ng-template>
        </div>
      </div>
    </section>
    <section id='body'>
      <section id="left-content">
        <!-- time-management start -->
        <div id="service-time-management" class="mat-card settings-card" formGroupName="time">
          <div class="card-innner-con">
            <div class="settings-card-title">
              <div class="operational-message-inline">
                <asp-icon name="ic-20-feedback-alert-error.svg" width="1rem"></asp-icon>
                {{ 'generalSettings.anyChangesMadeHereWillNotBeUpdatedInTheDMS' | translate }} <span class="dms" (click)="navigateToDIS()">DIS</span>
              </div>
              <div class="title-button">
                <button (click)=syncDealerDisDetails() class='refresh' type="button"
                  [title]="getIntegrationText()" 
                  [disabled]="syncInProgress"
                  [ngClass]="syncInProgress ? 'disabled': ''">
                  <ng-container *ngIf="syncInProgress; else serviceSettingsSyncLabel">
                    <app-loading loadingSymbol="dots" [text]="'servicePersonnel.syncInProgress' | translate" color="var(--primary-toyota-color)" size=".6" [compact]="true"></app-loading>
                  </ng-container>
                  <ng-template #serviceSettingsSyncLabel>
                    <asp-icon class="icon d-inline-block" name="ic-20-utility-update-small.svg" width="1.2rem"
                      height='1.2rem' color='var(--primary-toyota-color)'>
                    </asp-icon>
                    <span>{{ getIntegrationText() | translate }}</span>
                  </ng-template>
                </button>
              </div>
            </div>
            <div class="settings-card-body">
              <div class="time-management-overview">
                <div class="operational-container">
                  <div class="operational-title">
                    <span>{{ 'generalSettings.operationalHours' | translate}}</span>
                  </div>
                  <div class="operational-body">
                    <div class="field-container" *ngFor="let obj of hoursOfOperation">
                      <div class="filed-title">
                        <span>{{getTranslation(obj.day)}}</span>
                      </div>
                      <div class="filed-value">
                        <span class="optional-list-sub" [ngClass]="{'no-word-spacing' : obj.operation === 'Data not found in DIS'}">{{obj.operation === 'Closed' ? ('serviceSchedule.closed' | translate) :
                          obj.operation === 'Data not found in DIS' ? ('serviceSchedule.closedConfirm' | translate) : obj.operation}}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="time-management-splitter" aria-hidden="true"></div>

                <div class="amenities-container">
                  <div class="amenities-header-row">
                    <div class="operational-title">
                      <span>{{ 'generalSettings.amenities' | translate }}</span>
                    </div>
                    <div class="field-value custom-switch">
                      <app-onofswitch [switchInput]='portalSwitches.enableAmenities'
                        (switchChange)="updateSwitchValues($event, 'enableAmenities')"></app-onofswitch>
                      <div class="readonly-layer" *ngIf="!hasAmenities"></div>
                    </div>
                  </div>
                  <div class="amenities-body">
                    <ng-container *ngIf="hasAmenities; else noAmenitiesState">
                      <ul class="amenities-list">
                        <li *ngFor="let value of amenities">{{ value }}</li>
                      </ul>
                    </ng-container>
                    <ng-template #noAmenitiesState>
                      <div class="no-amenities-message">{{ 'generalSettings.noAmenitiesInDIS' | translate }}</div>
                    </ng-template>
                  </div>
                </div>
              </div>

              <div class="field-container time-settings-row">
                <div class="field-input">
                  <label>{{ 'generalSettings.timeSlotDuration' | translate }}</label>
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="slotDuration">
                      <mat-option [value]='obj.value' *ngFor="let obj of timeDuration">
                        {{ obj.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="field-input">
                  <label>{{ 'generalSettings.onlineAppointmentCut-offTime' | translate }}</label>
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="cutOffTime">
                      <mat-option [value]='obj.value' *ngFor="let obj of curOffTime">
                        {{ obj.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="field-container mt25">
                <div class="field-input">
                  <label>{{ 'generalSettings.timezone'| translate }}</label>
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="timeZone">
                      <mat-option [value]='obj.value' *ngFor="let obj of ((timezones$ | async) | alphabetize:'label')">
                        {{ obj.label }}
                      </mat-option>
                    </mat-select>
                    <mat-error>{{'generalSettings.timezoneIsrequired' | translate }}</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- time-management end -->
        <app-switch-card [title]="'generalSettings.alexaBooking'|translate" [value]="alexaEnabled" [tooltip]="tooltip.alexa" [label]="'generalSettings.enableAlexaBooking'|translate" (switchValueChange)="updateSwitchValues($event, 'alexaEnabled')" *ngIf="false">
        </app-switch-card>
        <!-- online-portal-settings start -->
        <div id="service-online-portal-settings" class="mat-card settings-card" formGroupName="portal" #portalcon>
          <div class="card-innner-con">
            <div class="settings-card-title">
              <span>{{ 'generalSettings.onlinePortalSettings' | translate}}</span>
              <span class="material-icons" [matTooltip]="tooltip.portal"
                matTooltipClass="asp-custom-tooltip">help_outline </span>
            </div>
            <div class="settings-card-body">
              <div class="field-container">
                <div class="filed-title">
                  <span>{{ 'generalSettings.showPricing' | translate }}</span>
                </div>
                <div class="filed-value custom-switch">
                  <app-onofswitch [switchInput]='portalSwitches.showPricing'
                    (switchChange)="updateSwitchValues($event, 'showPricing')"></app-onofswitch>
                    <div class="readonly-layer" *ngIf="dealerLexusFlag == true"></div>
                </div>
              </div>
              <div class="field-container">
                <div class="filed-title">
                  <span>{{'generalSettings.estimatedTimeInTheOnlinePortal' | translate}}</span>
                </div>
                <div class="filed-value custom-switch">
                  <app-onofswitch [switchInput]='portalSwitches.showEstimatedTime'
                    (switchChange)="updateSwitchValues($event, 'showEstimatedTime')">
                  </app-onofswitch>
                </div>
              </div>
              <div class="field-container">
                <div class="filed-title">
                  <span>{{ 'generalSettings.mandateVIN'| translate }}</span>
                </div>
                <div class="filed-value custom-switch">
                  <app-onofswitch [switchInput]='portalSwitches.mandateVin'
                    (switchChange)="updateSwitchValues($event, 'mandateVin')"></app-onofswitch>
                </div>
              </div>
              <!-- <div class="field-container">
                <div class="filed-title">
                  <span>{{'generalSettings.mandateCustomerAddress' | translate}}</span>
                </div>
                <div class="filed-value custom-switch">
                  <app-onofswitch [switchInput]='portalSwitches.mandateCustomerAddress'
                    (switchChange)="updateSwitchValues($event, 'mandateCustomerAddress')"></app-onofswitch>
                </div>
              </div> -->

              <div class="field-container mt25">
                <div class="field-input">
                  <label>{{'generalSettings.bannerTitleText' | translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="{{'generalSettings.enterBannerTitleText' | translate }}" formControlName="bannerTitleText" type="text">
                  </mat-form-field>
                </div>
                <div class="field-input">
                  <label>{{'generalSettings.bannerBodyText' | translate }}</label>
                  <mat-form-field class="no-fixed-height" appearance="outline">
                    <textarea matInput placeholder="{{'generalSettings.enterBannerBodyText' | translate }}" formControlName="bannerBodyText">
                                        </textarea>
                  </mat-form-field>
                </div>
              </div>
              <div class="field-container mt25">
                <div class="field-input">
                  <label>{{ 'generalSettings.upsellTextForAddOnOpcodes' | translate }}</label>
                  <mat-form-field class="no-fixed-height" appearance="outline">
                    <textarea matInput placeholder="{{'generalSettings.enterUpsellText' | translate }}" formControlName="upsellText">
                                        </textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- online-portal-settings end -->
        <!-- Capacity Management -->
        <div id="capacity-management-settings" class="mat-card settings-card" formGroupName="capacity" #capacity>
          <div class="card-innner-con">
            <div class="settings-card-title">
              <span>{{'generalSettings.capacityManagement' |translate }}</span>
              <span class="material-icons" [matTooltip]="tooltip.capacity"
                matTooltipClass="asp-custom-tooltip">help_outline </span>
            </div>
            <div class="settings-card-body">
              <div class="field-container">
                <span class="sub-heading">{{'generalSettings.quickSlotCapacitySetup' |translate }}</span>
              </div>
              <div class="field-container">
                <div class="field-input" style="width: 100%;">
                  <label> {{'generalSettings.dailyAverageServiceSlots' |translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="{{'generalSettings.enterAverageServiceSlots' |translate }}" formControlName="dailyAverageServiceSlots" type="number"
                      min="1" required>
                    <mat-error>
                      {{'generalSettings.pleaseEnterValue' |translate }} <strong>{{'generalSettings.greaterThan0' |translate }}</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="field-container">
                <span class="margin-allignment">{{'generalSettings.slotCapacityCalculationMethod' |translate }}</span>
              </div>
              <div class="field-container">
                  <div class="selection-container">
                    <div class="item" [ngClass]="{'selected' : slotsCalculationMethod === 'DAS' }"
                    [ngStyle]="{'padding': !isEnglishText ? '20px 10px' : '10px 10px' }" (click)="onSlotCapacityMethodChange('DAS')">
                        <span >{{'generalSettings.dailyAverageSlots' |translate }} ({{dailyAverageServiceSlots}})</span>
                    </div>
                    <div class="item" [ngClass]="{'selected' : slotsCalculationMethod === 'DCS'}"  (click)="onSlotCapacityMethodChange('DCS')">
                      <span style="text-align: center">{{'generalSettings.advancedSlotCapacitySetup' |translate }} ({{detailedCapcitySetup}})</span>
                    </div>
                </div>
              </div>
              <div class="field-container">
                <span class="sub-heading">{{'generalSettings.quickFrhCapacitySetup' |translate }}</span>
              </div>
              <div class="field-container">
                <div class="field-input" style="width: 100%;">
                  <label> {{'generalSettings.dailyAverageFlatRateHour(FRH)' |translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="{{'generalSettings.enterAverageFRH' |translate }}" formControlName="dailyFRH" type="number"
                      min="1" required>
                    <mat-error>
                      {{'generalSettings.pleaseEnterValue' |translate }} <strong>{{'generalSettings.greaterThan0' |translate }}</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="field-container">
                <span class="margin-allignment">{{'generalSettings.fRHCapacityCalculationMethod' |translate }}</span>
              </div>
              <div class="field-container">
                  <div class="selection-container">
                    <div class="item" [ngClass]="{'selected' : calculationMethod === 'DFRH'}" (click)="onCapacityMethodChange('DFRH')">
                        <span >{{'generalSettings.dailyAverageFRH' |translate }} ({{this.dailyAverageFRH}})</span>
                    </div>
                    <div class="item" [ngClass]="{'selected' : calculationMethod === 'SVPSU'}"  (click)="onCapacityMethodChange('SVPSU')">
                      <span>{{'generalSettings.advancedFrhCapacitySetup' |translate }} ({{this.servicePersonalSetup}})</span>
                    </div>
                </div>
              </div>
              <div class="field-container">
                <span class="sub-heading">{{'generalSettings.aSPFullfilment' | translate}}(%)</span>
              </div>
              <div class="field-container">
                <div class="field-input">
                  <label>{{ 'generalSettings.consumer/ExternalBDC'| translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="{{'generalSettings.enterFullfilment%' |translate }}" formControlName="tier1" type="number"
                      min="0" max="100">
                    <mat-error>
                      {{'generalSettings.pleaseEnterValue' |translate }} <strong >{{settingsForm.controls.capacity.get('tier1').errors?.required}}</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="field-input">
                  <label>{{ 'generalSettings.internalBDC' | translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="{{'generalSettings.enterFullfilment%' |translate }}" formControlName="tier2" type="number"
                      min="0" max="100" >
                    <mat-error>
                      {{'generalSettings.pleaseEnterValue' |translate }} <strong>{{settingsForm.controls.capacity.get('tier2').errors?.required}}</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="field-container">
                <div class="field-input">
                  <label>{{ 'generalSettings.serviceAdvisors'| translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="{{'generalSettings.enterFullfilment%' |translate }}" formControlName="tier3" type="number"
                      min="0" max="100" >
                    <mat-error>
                      {{'generalSettings.pleaseEnterValue' |translate }} <strong>{{settingsForm.controls.capacity.get('tier3').errors?.required}}</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="field-input">
                  <label>{{'generalSettings.assistantServiceManagers' | translate }}</label>
                  <mat-form-field appearance="outline">
                    <input matInput placeholder="{{'generalSettings.enterFullfilment%' |translate }}" formControlName="tier4" type="number"
                      min="0" max="100" >
                    <mat-error>
                      {{'generalSettings.pleaseEnterValue' |translate }} <strong >{{settingsForm.controls.capacity.get('tier4').errors?.required}}</strong>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="right-content">
        <!-- Transport Management start -->
        <div id="service-transport-management" class="mat-card settings-card" formGroupName="transport">
          <div class="card-innner-con">
            <div class="settings-card-title">
              <span>{{'generalSettings.transportationManagement' | translate }}</span>
              <span class="material-icons" [matTooltip]="tooltip.transport"
                matTooltipClass="asp-custom-tooltip">help_outline </span>
            </div>
            <ng-container formArrayName="transportOptions">
              <!-- Generated by Copilot- Start -->
              <div class="settings-card-body trans-card" 
              *ngFor="let transOptions of transportOptions.controls; let i = index" [formGroupName]="i"
              [style.display]="shouldHideTransportOption(transOptions.value.id) ? 'none' : null">
                <mat-checkbox class="trans-check" value="transOptions" formControlName="isActive"
                  (change)="setZipcodeValidation(transOptions.value, $event);onChangeValue(transOptions.value.isActive,i);" disableRipple>
                  {{getTranslation(transOptions.value.label)}}
                </mat-checkbox>
                <div class="trans-options" >
                  <mat-form-field appearance="outline" class="trans-comment">
                    <input matInput placeholder="{{'generalSettings.comments' | translate }}" formControlName="comments"  >
                  </mat-form-field>
                  <div style="
                  margin-left: 0.27rem; width:97%" *ngIf="transOptions.value.id == 'RENTAL' || transOptions.value.id == 'RIDE_SHARE'">
                    <div style="margin:0.1rem 0 0.2rem;"><strong>{{ transOptions.value.id == 'RIDE_SHARE' ? '' : ('generalSettings.complimentaryRentalCutOff' | translate) }}</strong></div>
                    <div class="trans" *ngIf="transOptions.value.id == 'RENTAL'">
                        <div class='col-6 p-0' >
                            <label style ="margin-left: 0.5rem">{{'generalSettings.costOfService' | translate }}</label>
                            <mat-form-field appearance="outline">
                              <div matPrefix style="margin-left: 1rem; padding-top: 0.3rem;">
                                {{ 'GLOBAL.CURRENCYSYMBOL' | translate }}</div>
                              <input matInput formControlName="cost" type="number">
                            </mat-form-field>
                        </div>
                        <div class='col-6 p-0'>
                            <label style ="margin-left: 0.5rem" >{{ 'teamManagement.flatRateHours' | translate | titlecase}}</label>
                            <mat-form-field appearance="outline" >
                                <input matInput formControlName="flatRateHours" type="number" >
                            </mat-form-field>
                        </div>
                    </div>
                  <div class= "settings-card-title-remote" *ngIf="transOptions.value.id == 'RIDE_SHARE'">
                    <strong>{{ 'Remote Transportations' }} </strong>
                  </div>
                  </div>
           
                </div>
              </div>
              <!-- Generated by Copilot- End -->
            
            </ng-container>
            <div  class="trans-card" >
              <label  style='padding-left:16px;padding-top: 8px'>{{'generalSettings.estimatedPickupDuration(H)' | translate }}</label>
              <mat-form-field style="padding-left:35px"  appearance="outline" >
                <input   matInput  formControlName="estimatedDuration" type="number" >
              </mat-form-field>
            </div>
            <div class="trans-card" *ngIf="isUsDealer && (zipcodes$ | async)?.length > 0">
              <div class="trans-check" >{{'generalSettings.includeRemoteZipCode' | translate }}</div>
              <mat-form-field  style="padding-left: 1.15rem" appearance="outline">
                <mat-select style="padding-left: 0.5rem;"  multiple disableRipple placeholder="{{'generalSettings.select' | translate}}" formControlName="includedRemoteZipCodes">
                  <mat-option *ngFor="let zipcode of zipcodes$ | async" [value]="zipcode">{{zipcode}}
                  </mat-option>
                </mat-select>
                <mat-error>{{'generalSettings.remoteZipCodeIsRequired' | translate }}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <!-- Transport Management end -->

        <div id="service-reminder-email-settings" class="mat-card settings-card" #remindermailcon>
          <div class="card-innner-con">
            <div class="settings-card-title">
              <span>{{ 'generalSettings.customerNotification' | translate}}</span>
              <span class="material-icons" [matTooltip]="tooltip.customerNotification"
                matTooltipClass="asp-custom-tooltip">help_outline </span>
            </div>
            <div class="settings-card-body">
              <div class="field-container">
                <div class="filed-title">
                  <span>{{ 'generalSettings.enableCustomerNotification' | translate }}</span>
                </div>
                <div class="settings-spacer"></div>
                <div class="filed-value custom-switch">
                  <app-onofswitch [switchInput]='customerNotificationEnabled'
                    (switchChange)="updateSwitchValues($event, 'customerNotificationEnabled')"></app-onofswitch>
                </div>
              </div>
              <div class="field-container">
                <div class="filed-title">
                  <span>{{ 'generalSettings.reminderNotification' | translate }}</span>
                </div>
                <div class="settings-spacer"></div>
                <div class="filed-value custom-switch"  [ngStyle]="{'pointer-events': settingsForm.controls['customerNotificationEnabled'].value ? '' : 'none'}">
                  <app-onofswitch [switchInput]='reminderNotificationEnabled'
                    (switchChange)="updateSwitchValues($event, 'reminderNotificationEnabled')"></app-onofswitch>
                </div>
              </div>
              <div class="trans-card">
                <div class="trans-check">{{'generalSettings.selectReminderSchedule' | translate }}</div>
                <mat-form-field appearance="outline">
                  <mat-select multiple disableRipple placeholder="{{'generalSettings.select' | translate}}" formControlName="reminderNotificationSchedule">
                    <mat-option *ngFor="let scheduleVal of scheduleValues" [value]="scheduleVal">{{scheduleVal}}
                    </mat-option>
                  </mat-select>
                  <mat-error>{{'generalSettings.reminderScheduleIsRequired' | translate }}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>




        <!-- Alert Notification Settings start -->
        <div id="service-alert-settings" formGroupName="notification" class="mat-card settings-card"
          [style.height.px]="setAlertConHight(portalcon)">
          <div class="card-innner-con">
            <div class="settings-card-title">
              <span>{{'generalSettings.alertNotificationSettings' | translate }}</span>
              <span class="material-icons" [matTooltip]="tooltip.notifications"
                matTooltipClass="asp-custom-tooltip">help_outline </span>
            </div>
            <div class="settings-card-body" *ngFor="let item of notificationList">
              <div class="field-container">
                <div class="filed-title">
                  <span>{{item.header | translate}}</span>
                </div>
                <div class="settings-spacer"></div>
                <div class="filed-value custom-switch">
                  <app-onofswitch [switchInput]='isEnable(item.name)'
                    (switchChange)="updateSwitchValues($event, item.name)"></app-onofswitch>
                  <div class="readonly-layer" *ngIf="item.name === 'syncFailure'"></div>
                </div>
              </div>

              <div class="d-flex flex-column" [formGroupName]="item.name">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>{{'generalSettings.emailAddress' | translate }}</mat-panel-title>
                    </mat-expansion-panel-header>

                    <ng-container formArrayName="distributionList">
                      <div class="settings-card-body trans-card d-flex"
                        *ngFor="let email of distributionList(item.name)?.controls; let i = index">
                        <mat-form-field appearance="outline" class="trans-comment">
                          <input matInput maxlength="128" [formControlName]="i">
                          <mat-error>{{ 'generalSettings.pleaseEnterValidEmail' | translate }}</mat-error>
                        </mat-form-field>
                        <button class="btn asp-btn-secondary asp-btn-height my-auto d-flex align-items-center"
                          (click)="removeDistributionList(item.name,i)">
                          <asp-icon name="ic-20-utility-delete-trash.svg" width="1rem" color='rgba(14,19,25,0.8)'></asp-icon>
                        </button>
                      </div>
                    </ng-container>
                    <button class="btn asp-btn-primary asp-btn-width asp-btn-height mt-2" style="margin-left: 5px;width: 10rem;"
                      (click)="addDistributionList(item.name)">{{'generalSettings.addnew' | translate }}</button>
                  </mat-expansion-panel>
                </mat-accordion>


              </div>

            </div>
          </div>
        </div>
        <!-- Alert Notification Settings end -->
      </section>
    </section>
  </form>
</section>
